import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    let element = this.element;
    element.classList.add("show");
    setTimeout(() => { element.classList.remove("show") }, 5000);
  }

}
